import { computed, unref } from '@vue/composition-api';
import { normalizeMatchedClusters } from './useCompetitorActivity.js';

/**
 * Normalizes competitor expiring contract rows (matched_clusters + legacy cluster fields).
 *
 * @param {Array} raw - competitor_expiring_contracts from daily digest API
 * @returns {Array<Object>}
 */
export function normalizeCompetitorExpiringContracts(raw) {
  if (!Array.isArray(raw) || raw.length === 0) return [];
  return raw.map((item) => ({
    ...item,
    matched_clusters: normalizeMatchedClusters(item)
  }));
}

/**
 * Composable for the "competitor" expiring contracts section.
 * Uses the shared Daily Digest instance to derive competitor_expiring_contracts.
 *
 * @param {Object} params - Configuration
 * @param {Object} params.dailyDigest - dailyDigest ref from useDailyDigest
 * @param {Object} params.loading - loading ref from useDailyDigest
 * @returns {Object} Object containing reactive state for competitor expiring contracts section
 */
export function useCompetitionExpiringContractsSection({ dailyDigest, loading }) {
  /**
   * Competitor expiring contracts from daily digest data.
   * @returns {Array} Array of competitor expiring contract objects, or empty array if none available
   */
  const competitorExpiringContracts = computed(() => {
    const digest = unref(dailyDigest);
    const raw = digest?.competitor_expiring_contracts;
    return normalizeCompetitorExpiringContracts(raw || []);
  });

  /**
   * Reuse the shared loading state from the Daily Digest composable.
   */
  const loadingCompetitorExpiringContracts = loading;

  return {
    competitorExpiringContracts,
    loading: loadingCompetitorExpiringContracts
  };
}

